/**
 * TypeScript types for Tenant API
 * Matching API contracts from docs/apis/tenants.md
 */

export enum TenantType {
  CUSTOMER = "CUSTOMER",
  LOCAL_TEAM = "LSP",
}

export enum TenantStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface CustomerAdmin {
  given_name: string;
  surname?: string;
  other_name?: string;
  preferred_name?: string;
  contact_email: string;
  country: string; // 3 character country code
  phone_code?: string;
  phone_number?: string;
}

export interface CreateTenantRequest {
  tenant_name: string;
  type: TenantType;
  demo_tenant?: boolean;
  account_name: string;
  domains: string[];
  total_number_of_users: number;
  salesforce_id: string;
  country: string; // 2 character country code
  status: TenantStatus;
  billing_start_date: string; // DD/MM/YYYY format (string for API)
  billing_end_date?: string | null; // DD/MM/YYYY format (string for API)
  organization_id: string; // UUID
  customer_admin: CustomerAdmin;
  supports_payroll_plus?: boolean;
  payslip_portal_link?: string;
  account_manager_id?: string; // UUID of the account manager
}

/**
 * Internal form data uses Date objects, but API expects DD/MM/YYYY strings
 */
export interface CreateTenantRequestInternal {
  tenant_name: string;
  type: TenantType;
  demo_tenant?: boolean;
  account_name: string;
  domains: string[];
  total_number_of_users: number;
  salesforce_id: string;
  country: string;
  status: TenantStatus;
  billing_start_date: Date; // Date object for validation
  billing_end_date?: Date | null; // Date object for validation
  organization_id: string;
  customer_admin: CustomerAdmin;
}

export interface CreateTenantResponse {
  tenant_id: string;
  customer_admin_id: string;
}

export interface VerifyDomainAvailabilityRequest {
  domains: string[];
}

export interface DomainAvailabilityResult {
  domain: string;
  available: boolean;
  tenant_id: string | null;
  tenant_name: string | null;
}

export interface VerifyDomainAvailabilityResponse {
  results: DomainAvailabilityResult[];
}

export interface TenantListItem {
  id: string;
  tenant_name: string;
  type: TenantType;
  demo_tenant: boolean;
  account_name: string;
  domains: string[];
  total_number_of_users: number;
  salesforce_id: string;
  country: string;
  status: TenantStatus;
  billing_start_date: string | null; // ISO 8601 format
  billing_end_date: string | null; // ISO 8601 format
  organization_id: string;
  createdAt: string; // ISO 8601 format
  updatedAt: string; // ISO 8601 format
  customer_admin: {
    id: string;
    given_name: string;
    surname: string | null;
    contact_email: string;
    country: string;
  } | null;
}
